
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { MessageService } from 'primeng/api';
import { AddressModel } from './address.model';
import { AddressService } from '../services/address-service/address.service'
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { CountryModel } from '../country/country.model';
import { CountryService } from '../services/country-service/country.service';
import { ValidationService } from '../services/validation-service/validation-service';
import {cloneDeep} from 'lodash';


@Component({
  selector: 'app-address',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.css'],
  providers: [AddressService, ConfirmationService, MessageService, CountryService, ValidationService]
})

export class AddressComponent implements OnInit {

  addressForm: UntypedFormGroup;
  get f() { return this.addressForm.controls; }
  serviceResponse: any;
   public alphaNumericRegEx =/[~`!@#$%^()_={}[\]:;,.<>+\/?-]/;
  @Input() visible: boolean;
  @Input() addressModel: AddressModel;
  @Input() recipientEmail: string;
  @Output() eventToReceiveNewCreatedAddress = new EventEmitter<AddressModel>();
  @Output() eventToCloseAddressPopUp = new EventEmitter<AddressModel>();

  @Input() recipientType?: string;

  validatedAddress: AddressModel = new AddressModel(); 
  assignedCountry: string = "";
  errorMessage: string = "";
  showSuggestedAddress: boolean = false;
  shouldValidateAddress: boolean = true;
  disableNonEditableField: boolean = false;
  isStateRequired: boolean = false;
  invalidAddressLine:boolean = false;

  countryList: CountryModel[] = [];
  selectedCountry: CountryModel;
  addressList: AddressModel[] = [];

  submitted = false;
  contentStyleObject: object = {
    'width': '53vw',
    'max-height': '75vh',
    'overflow': 'auto',
  }
  constructor(private _formBuilder: UntypedFormBuilder, private addressService: AddressService, private confirmationService: ConfirmationService,
    private countryService: CountryService, private messageService: MessageService, public validationService: ValidationService
  ) {

  }

  ngOnInit() {
    this.addressForm = this._formBuilder.group({
      addressLine1: ['', Validators.required],
      addressLine2: [''],
      addressLine3: [''],
      company: ['', Validators.required],
      contactNumber: ['', Validators.required],
      zipCode: ['', Validators.required],
      city: ['', Validators.required],
      state: [''],
      country: ['', Validators.required]
    });

    // Always reset validation flag when initializing the form
    this.shouldValidateAddress = true;
    this.getCountryList();
    
    // Always enable address validation for both internal and external recipients
    this.shouldValidateAddress = true;

    if (this.addressModel.AddressId > 0) {
      this.disableNonEditableField = true;
    }
    else {
      this.disableNonEditableField = false;
    }

    this.addressForm.get('country').valueChanges
  .subscribe(value => {
     
    if(value?.Name == "UNITED STATES") {
      this.addressForm.controls['state'].setValidators([Validators.required]);
      this.isStateRequired = true;
      this.shouldValidateAddress = true;
      
      // If zip code already has a value, trigger validation for US addresses
      if (this.addressModel?.PostalCode) {
        this.GetStateAndCityFromZip();
      }
    } else {
      this.addressForm.controls['state'].clearValidators();
      this.isStateRequired = false;
      this.shouldValidateAddress = false;
      
      // Clear any zip code validation errors when switching to non-US country
      if (this.errorMessage.indexOf('Zip') !== -1 || this.errorMessage.indexOf('ZIP') !== -1) {
        this.errorMessage = "";
        this.invalidAddressLine = false;
      }
    }
    this.addressForm.controls['state'].updateValueAndValidity();
  });

    if (this.addressModel.CountryId > 0) {
      this.selectedCountry = { CountryId: this.addressModel.CountryId, Name: this.addressModel.Country };
    }

    if (this.recipientType == "External") {
      this.assignedCountry = this.addressModel.Country;
      if (this.addressModel.AddressId > 0) {
        this.disableNonEditableField = true;
      }
      
      // For external recipients with US addresses, ensure zip code validation is enabled
      if (this.addressModel.Country === "UNITED STATES") {
        // External recipient with US address - enable validation
        this.shouldValidateAddress = true;
      }
    }

    this.getCountryList();


  }

 public RestrictUnwantedCharecters(e)
 {
  
  if(!this.alphaNumericRegEx.test(e.key)) {
    return true;
  }
  else{
   e.preventDefault();
   return false;
  }  
 }
  //------------------------------------------------
  // To save address
  //------------------------------------------------
  saveAddress() {
    this.submitted = true;
    // stop here if form is invalid 
    if (this.addressForm.invalid) {
      return;
    }
    else {
      if (this.recipientType == "External") {
        if (this.assignedCountry != "" && this.assignedCountry != null && this.assignedCountry != this.selectedCountry.Name) {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: this.assignedCountry + " is the assigned country to the recipient. Please select " + this.assignedCountry });
          return;
        }
      }
      // console.log("All the field(s) are valid. Call service()");
      this.addressModel.CountryId = this.selectedCountry.CountryId;
      this.addressModel.Country = this.selectedCountry.Name;
      this.invalidAddressLine = false;
      
      // Log validation state for debugging
      // console.log('Address validation state:', {
      //   country: this.selectedCountry?.Name,
      //   isUS: this.selectedCountry?.Name === "UNITED STATES",
      //   hasAddressLine: this.addressModel?.AddressLine1 != null && this.addressModel?.AddressLine1.trim().length > 0,
      //   shouldValidateAddress: this.shouldValidateAddress,
      //   willValidate: this.selectedCountry?.Name === "UNITED STATES" && 
      //                this.addressModel?.AddressLine1 != null && 
      //                this.addressModel?.AddressLine1.trim().length > 0 && 
      //                this.shouldValidateAddress
      // });
      
      if( this.selectedCountry.Name == "UNITED STATES" && this.addressModel?.AddressLine1 != null  
      && this.addressModel?.AddressLine1.trim().length > 0 && this.shouldValidateAddress)
      {
            this.addressService.ValidateAddressLine1(this.addressModel).subscribe(res => {
              // console.log('USPS v3 validation response:', res);
              
              // Check if the address is valid - handle both USPS v2 and v3 formats
              // console.log('Checking if address is valid with USPS v3');
              
              // Check for error indicators in USPS v3 response based on the backend API code
              // The backend returns a USPSv3AddressResponse object with either:
              // 1. A valid Address property (success)
              // 2. An Error property (validation error)
              // 3. Errors in the Matches array
              
              // First, log the entire response for debugging
              // console.log('USPS v3 full response structure:', res);
              
              // Check if the response contains an Error property (validation failed)
              const hasErrorProperty = res && res.Error && res.Error.Message;
              
              // Check if the response is missing the Address property (also an error)
              const missingAddressProperty = !res || !res.Address;
              
              // Check if the Address property has an Error (legacy format)
              const addressHasError = res && res.Address && res.Address.Error;
              
              // Check for errors in the Matches array (USPS v3 format)
              const hasMatchesError = res && res.Matches && res.Matches.length > 0 && 
                                    res.Matches.some(match => match.Code === 'ERROR');
              
              // Check for successful match in the Matches array (USPS v3 format)
              const hasSuccessMatch = res && res.Matches && res.Matches.length > 0 && 
                                   (res.Matches.some(match => match.Code === '31') || 
                                    res.Matches.some(match => match.Text && match.Text.includes('exact match')));
              
              // Also check if StreetAddress is null in the Address object (indicates validation failure)
              const missingStreetAddress = res && res.Address && res.Address.StreetAddress === null;
              
              // Check if the address object has all required fields populated (indicates success)
              const hasCompleteAddress = res && res.Address && 
                                       res.Address.StreetAddress && 
                                       res.Address.City && 
                                       res.Address.State && 
                                       res.Address.ZIPCode;
              
              // An address is valid if it has a complete address and either a success match or no errors
              const hasError = hasErrorProperty || missingAddressProperty || addressHasError || 
                             hasMatchesError || missingStreetAddress;
                             
              // Override hasError if we have a successful match
              const isValid = hasSuccessMatch || (hasCompleteAddress && !hasError);
              
              // console.log('Address validation details:', {
              //   hasErrorProperty,
              //   missingAddressProperty,
              //   addressHasError,
              //   hasMatchesError,
              //   hasSuccessMatch,
              //   missingStreetAddress,
              //   hasCompleteAddress,
              //   hasError,
              //   isValid
              // });
              
              // console.log('USPS validation error analysis:', { 
              //   hasErrorProperty, 
              //   missingAddressProperty, 
              //   addressHasError,
              //   hasMatchesError,
              //   missingStreetAddress,
              //   hasError,
              //   isValid,
              //   response: res 
              // });
              
              if(isValid)
              {
                // Extract address data from response - handle both v2 and v3 formats
                const uspsAddress = res.Address;
                
                // Log the full USPS response for debugging
                // console.log('USPS v3 full response:', res);
                // console.log('USPS address object:', uspsAddress);
                
                // Map properties from USPS v3 API response format
                // Based on the Swagger example response structure
                const postalCode = uspsAddress.ZIPCode || uspsAddress.Zip5;
                const city = uspsAddress.City;
                const addressLine = uspsAddress.StreetAddress || uspsAddress.Address || uspsAddress.Address2;
                const state = uspsAddress.State;
                
                // Log extracted values
                // console.log('Extracted USPS data:', { postalCode, city, addressLine, state });
                // console.log('User entered data:', { 
                //   postalCode: this.addressModel.PostalCode,
                //   city: this.addressModel.City,
                //   addressLine: this.addressModel.AddressLine1,
                //   state: this.addressModel.State
                // });
                
                const hasValidData = postalCode && city && addressLine && state;
                
                // Log comparison results
                const postalCodeDiff = this.addressModel.PostalCode != postalCode;
                const cityDiff = this.addressModel.City != city;
                const addressLineDiff = this.addressModel.AddressLine1 != addressLine;
                const stateDiff = this.addressModel.State != state;
                
                // console.log('Differences detected:', { 
                //   postalCodeDiff, 
                //   cityDiff, 
                //   addressLineDiff, 
                //   stateDiff,
                //   hasValidData,
                //   shouldShowSuggestion: hasValidData && (postalCodeDiff || cityDiff || addressLineDiff || stateDiff)
                // });
                
                if(hasValidData && 
                   (postalCodeDiff || cityDiff || addressLineDiff || stateDiff))
                {
                  // console.log('Showing address suggestion popup');
                  this.validatedAddress.PostalCode = postalCode;
                  this.validatedAddress.City = city;
                  this.validatedAddress.AddressLine1 = addressLine;
                  this.validatedAddress.State = state;
                  this.showSuggestedAddress = true;                              
                }
                else
                {
                  if (this.addressModel.AddressId > 0) {
                    this.callServiceToUpdateAddress();
                  } else {
                    this.callServiceToSaveAddress();
                  }
                }
              } else {
                // Address is invalid, show error message
                // console.log('USPS v3 full response:', res);
                
                // We'll use this error message for the popup, but NOT display it on the form
                // This way we avoid showing validation errors on the form itself
                let errorMessage = 'USPS could not validate this address';
                // console.log('Address validation failed, preparing popup message');
                
                // Extract error message based on the backend API response format
                // The backend uses CreateErrorAddressResponse() which sets an Error property
                if (res && res.Error && res.Error.Message) {
                  // Standard USPS v3 error format from the backend
                  errorMessage = res.Error.Message;
                  // console.log('USPS v3 error message from Error.Message:', res.Error.Message);
                } 
                else if (res && res.Matches && res.Matches.length > 0 && res.Matches.some(match => match.Code === 'ERROR')) {
                  // USPS v3 format with error in Matches array
                  const errorMatch = res.Matches.find(match => match.Code === 'ERROR');
                  if (errorMatch && errorMatch.Text) {
                    errorMessage = errorMatch.Text;
                    // console.log('USPS v3 error from Matches array:', errorMatch.Text);
                  }
                }
                else if (res && res.Address && res.Address.Error && res.Address.Error.Description) {
                  // Legacy format with error in Address object
                  errorMessage = res.Address.Error.Description;
                  // console.log('Legacy error format from Address.Error.Description:', res.Address.Error.Description);
                }
                else if (res && res.ErrorMessage) {
                  // Alternative error format with ErrorMessage property
                  errorMessage = res.ErrorMessage;
                  // console.log('Alternative error format from ErrorMessage:', res.ErrorMessage);
                }
                else if (!res || !res.Address) {
                  // Missing Address property
                  errorMessage = 'Invalid address format or missing address information';
                  // console.log('Error due to missing Address property');
                }
                else if (res && res.Address && res.Address.StreetAddress === null) {
                  // Missing StreetAddress in Address object
                  errorMessage = 'Invalid street address';
                  // console.log('Error due to missing StreetAddress in Address object');
                }
                
                // We're not setting this.errorMessage here to avoid showing errors on the form
                // this.errorMessage = errorMessage;
                // console.log('Final error message prepared for popup:', errorMessage);
                
                // console.log('Showing address validation error popup');
                
                // Create a more informative message based on the error
                let confirmMessage = 'USPS does not consider this address valid. ';
                
                // Check if all required fields are provided
                const allFieldsProvided = this.addressModel.AddressLine1 && 
                                         this.addressModel.City && 
                                         this.addressModel.State && 
                                         this.addressModel.PostalCode;
                
                if (allFieldsProvided) {
                  // If all fields are provided but validation still fails, it's likely because
                  // the street doesn't exist in that city/state/ZIP combination
                  confirmMessage = 'USPS could not verify this address. The street address "' + 
                                  this.addressModel.AddressLine1 + '" could not be found in ' + 
                                  this.addressModel.City + ', ' + 
                                  this.addressModel.State + ' ' + 
                                  this.addressModel.PostalCode + '.';
                } 
                else if (res && res.Matches && res.Matches.length > 0) {
                  const errorMatch = res.Matches.find(match => match.Code === 'ERROR');
                  if (errorMatch && errorMatch.Text) {
                    // Handle specific error messages
                    if (errorMatch.Text.includes('provide all required address fields') && allFieldsProvided) {
                      // If the error says fields are missing but they're not, provide a better message
                      confirmMessage = 'USPS could not verify this address. The address appears to be invalid or incomplete according to USPS records.';
                    } 
                    else if (errorMatch.Text.includes('Address Not Found')) {
                      // Handle the specific "Address Not Found" error from your Swagger example
                      confirmMessage = 'USPS could not verify this address. The street address "' + 
                                      this.addressModel.AddressLine1 + '" could not be found in ' + 
                                      this.addressModel.City + ', ' + 
                                      this.addressModel.State + ' ' + 
                                      this.addressModel.PostalCode + '.';
                    }
                    else {
                      // For other error messages, use them directly
                      confirmMessage = 'USPS validation error: ' + errorMatch.Text + '. Do you still want to continue?';
                      // Remove the extra "Do you still want to continue?" that gets added later
                      return;
                    }
                  }
                } 
                else if (res && res.Address && res.Address.StreetAddress === null) {
                  // This is the most common case - street address couldn't be validated
                  confirmMessage = 'USPS could not verify this address. The street address "' + 
                                  this.addressModel.AddressLine1 + '" could not be found in ' + 
                                  this.addressModel.City + ', ' + 
                                  this.addressModel.State + ' ' + 
                                  this.addressModel.PostalCode + '.';
                } 
                else {
                  // Generic case
                  confirmMessage += 'The address could not be verified by USPS.';
                }
                
                confirmMessage += ' Do you still want to continue?';
                
                //show yes/no popup
                this.confirmationService.confirm({
                  message: confirmMessage,
                  header: 'Address Not Found',
                  icon: 'pi pi-exclamation-triangle',
                  accept: () => {                           
                    // User clicked Yes - proceed with saving the address
                    // We don't need to set the error message on the form since we're saving anyway
                    this.shouldValidateAddress = false;
                    this.callServiceToSaveAddress();
                  },
                  reject: () => {
                    // When user clicks No, make sure no validation errors are shown
                    // console.log('User rejected saving invalid address');
                    this.errorMessage = '';
                    // Reset validation state
                    this.submitted = false;
                    // Clear any validation errors from the form
                    this.clearValidationErrors();
                  }
                });            
              }
            },
              error => {
                console.error('API error during address validation:', error);
                this.invalidAddressLine = true;
                
                // Create a more descriptive error message
                let errorMessage = 'Error validating address with USPS';
                if (error.error) {
                  if (typeof error.error === 'string') {
                    errorMessage = error.error;
                  } else if (error.error.message) {
                    errorMessage = error.error.message;
                  }
                }
                
                this.errorMessage = errorMessage;
                // console.log('Setting error message:', errorMessage);
                
                // Show confirmation dialog for API errors
                this.confirmationService.confirm({
                  message: 'There was a problem validating this address with USPS. The address may be invalid. Do you still want to continue?',
                  header: 'Address Validation Error',
                  icon: 'pi pi-exclamation-triangle',
                  accept: () => {                           
                    this.shouldValidateAddress = false;
                    this.callServiceToSaveAddress();
                  }
                });
              });
      }
      else{
        if (this.addressModel.AddressId > 0) {
          this.callServiceToUpdateAddress();
        }
        else {
          this.callServiceToSaveAddress();
        }
      }
      
    }
  }
  closePopUp(){
 this.showSuggestedAddress = false;
  }

  UseEnteredAddress(){
    this.showSuggestedAddress = false;
    if (this.addressModel.AddressId > 0) {
      this.callServiceToUpdateAddress();
    }
    else {
      this.callServiceToSaveAddress();
    }
  }

  AcceptUSPSAddress(){
    this.showSuggestedAddress = false;
    
    // Update the addressModel
    this.addressModel.PostalCode = this.validatedAddress.PostalCode;
    this.addressModel.City = this.validatedAddress.City;
    this.addressModel.AddressLine1 = this.validatedAddress.AddressLine1;
    this.addressModel.State = this.validatedAddress.State;
    
    // Update the form controls to match the model
    this.addressForm.get('zipCode').setValue(this.validatedAddress.PostalCode);
    this.addressForm.get('city').setValue(this.validatedAddress.City);
    this.addressForm.get('addressLine1').setValue(this.validatedAddress.AddressLine1);
    this.addressForm.get('state').setValue(this.validatedAddress.State);
    
    // Clear any validation errors
    this.submitted = false;
    this.errorMessage = "";

    if (this.addressModel.AddressId > 0) {
      this.callServiceToUpdateAddress();
    }
    else {
      this.callServiceToSaveAddress();
    }
  }

  public clearErroMessage(messages)
  {
    if(this.errorMessage.indexOf(messages) !== -1)
    {
      this.errorMessage = "";
      this.invalidAddressLine = false;
    }
  }
  public ValidateAddressLine()
{
  this.invalidAddressLine = false;
  if( this.selectedCountry.Name == "UNITED STATES" && this.addressModel?.AddressLine1 != null  && this.addressModel?.AddressLine1.trim().length > 0)
  {
  this.addressService.ValidateAddressLine1(this.addressModel).subscribe(res => {
    this.invalidAddressLine = !res;
  },
    error => {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: error.error });
    });
  }
}

public GetStateAndCityFromZip()
{
  if( this.selectedCountry.Name == "UNITED STATES" && this.addressModel?.PostalCode != null)
  {
      this.addressService.GetStateAndCityForZip(this.addressModel?.PostalCode).subscribe(res => {
        // Handle both USPS v2 and v3 formats
        if((res.ZipCode && res.ZipCode.Error == null) || (res.PostalData && !res.Error))
        {
          // Clear any previous error messages
          if(this.errorMessage.indexOf('ZIP') !== -1 || this.errorMessage.indexOf('Zip') !== -1) {
            this.errorMessage = "";
            this.invalidAddressLine = false;
          }
          
          // Get data from the appropriate format (v2 or v3)
          const zipData = res.ZipCode || res.PostalData;
          
          if(zipData && zipData.City && this.addressModel.City != zipData.City)
          {
            this.addressModel.City = zipData.City;
          }
          
          if(zipData && zipData.State && this.addressModel.State != zipData.State)
          {
            this.addressModel.State = zipData.State;
          }
        }
        else
        {
          this.invalidAddressLine = true;
          
          // Handle error message from different formats
          if (res && res.Error && res.Error.Message) {
            // USPS v3 format
            this.errorMessage = res.Error.Message;
          } else if (res && res.ZipCode && res.ZipCode.Error) {
            // Legacy format
            this.errorMessage = res.ZipCode.Error.Description;
          } else {
            // Default error
            this.errorMessage = 'Unable to validate zip code';
          }
        }
      });
  }
}
public DisplayCommanError()
{
  return this.errorMessage.indexOf('Address') == -1 && this.errorMessage.indexOf('City') == -1 
  && this.errorMessage.indexOf('Zip') == -1 && this.errorMessage.indexOf('State') == -1;
}
  //-----------------------------------------------
  // Call api to save the address
  //-----------------------------------------------
  public callServiceToSaveAddress() {

    // console.log("Calling api to create a new address for selected recipient");
    this.addressService.createAddress(this.addressModel, this.recipientEmail).subscribe(res => this.serviceResponse = res,
      error => {
        console.error('Error creating address:', error);
        console.error('Error details:', error.error);
        
        // Display a more detailed error message to the user
        let errorMessage = 'An error occurred while saving the address.';
        if (error.error) {
          if (typeof error.error === 'string') {
            errorMessage = error.error;
          } else if (error.error.message) {
            errorMessage = error.error.message;
          }
        }
        
        this.messageService.add({ severity: 'error', summary: 'Error', detail: errorMessage });
      },
      () => {
        this.addressModel.AddressId = this.serviceResponse;
        if (this.addressModel.AddressId == 0) {
          this.messageService.add({ severity: 'error', summary: '', detail: 'Address already exists with the recipient' })
          return false;
        }
        else {
          // console.log("Address added for selected recipient with address id = " + this.serviceResponse);
          this.messageService.add({ severity: 'success', summary: 'Address saved successfully', detail: '', life: 500 });
          this.actionAfterSaveAndUpdateSuccess();
        }
      });
  }

  //-----------------------------------------------
  // Call api to update the address
  //-----------------------------------------------
  public callServiceToUpdateAddress() {
    // console.log("Calling api to update selected address id = " + this.addressModel.AddressId);
    this.addressService.updateAddress(this.addressModel, this.recipientEmail).subscribe(res => this.serviceResponse = res,
      error => {
        console.error('Error updating address:', error);
        console.error('Error details:', error.error);
        
        // Display a more detailed error message to the user
        let errorMessage = 'An error occurred while updating the address.';
        if (error.error) {
          if (typeof error.error === 'string') {
            errorMessage = error.error;
          } else if (error.error.message) {
            errorMessage = error.error.message;
          }
        }
        
        this.messageService.add({ severity: 'error', summary: 'Error', detail: errorMessage });
      },
      () => {
        // console.log("Address upadted for address id = " + this.addressModel.AddressId);
        this.messageService.add({ severity: 'success', summary: 'Address updated successfully', detail: '', life: 500 });
        this.actionAfterSaveAndUpdateSuccess();
      });
  }

  //----------------------------------------------------
  // Action need to be done once save/update success
  //----------------------------------------------------
  public actionAfterSaveAndUpdateSuccess() {
    this.eventToReceiveNewCreatedAddress.emit(cloneDeep(this.addressModel));
    this.visible = false;
    this.submitted = false;
    this.addressForm.reset();
  }

  //--------------------------------
  // close address dialog pop up
  //--------------------------------
  public closeAddressDialog() {
    this.eventToCloseAddressPopUp.emit();
    this.submitted = false;
    this.addressForm.reset();
  }

  //------------------------------------
  // To get the list of address
  //-----------------------------------
  public getCountryList() {
    if (this.countryList.length == 0) {
      this.countryService.getCountryList().subscribe(res => this.serviceResponse = res,
        error => {
          this.messageService.add({ severity: 'error', summary: '', detail: 'Error occurred while fetching data. Contact the Administrator' })
        },
        () => {
          this.countryList = this.serviceResponse;
        })
    }
  }

  //------------------------------------
  // Clear validation errors from the form
  //------------------------------------
  private clearValidationErrors() {
    // Reset the validation messages
    this.errorMessage = '';
    
    // Clear the validation errors in the form
    Object.keys(this.addressForm.controls).forEach(key => {
      const control = this.addressForm.get(key);
      if (control) {
        control.setErrors(null);
      }
    });
    
    // Remove any validation error messages displayed on the form
    const errorElements = document.querySelectorAll('.validation-error');
    errorElements.forEach(element => {
      element.textContent = '';
    });
    
    // console.log('Cleared validation errors');
  }

}

